import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Land')

export default {
  label: 'Land',
  route: 'land',
  fields: [
    Filter.String('alpha2code'),
    Filter.String('alpha3code'),
    Filter.String('nameDE'),
    Filter.String('nameEN'),
    Filter.String('numericCode')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/LandFilter.js